import React from "react";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import CustomTextInput from "../CustomTextInput";
import CustomButton from "../CustomButton";
import withStyles from "@material-ui/core/styles/withStyles";
import Color from "../../../utils/Color";

const CustomOTP = ({
  classes,
  onChangeOTP,
  otp,
  onClickVerify,
  onClickResend,
  phoneNo = "xxxx-",
  MobilePhoneLabel,
  onClickBack,
  handleKeypress,
  forgetPasswordAction,
}) => {
  return (
    <div>
      <CustomText design={classes.headerTextStyle}>Enter OTP</CustomText>
      {forgetPasswordAction === false ? (
        <CustomText design={classes.descTextStyle}>
          A One-Time Password has been sent to {phoneNo}
          {MobilePhoneLabel}
        </CustomText>
      ) : (
        <CustomText design={classes.descTextStyle}>
          Please enter the one-time password sent to your registered mobile
          number with Etiqa.
        </CustomText>
      )}

      <div className={classes.inputContainer}>
        <CustomTextInput
          type={"password"}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={otp}
          onChange={onChangeOTP}
          autoFocus={true}
          onKeyUp={handleKeypress}
        />
      </div>
      <CustomText onClick={onClickResend} design={classes.resendTextStyle}>
        Resend One-Time Password
      </CustomText>
      <div style={{ paddingRight: "1em", display: "inline-block" }}>
        <CustomButton
          title={"Back"}
          //design={classes.buttonStyle}
          design={classes.backButton}
          textstyle={classes.backButtonTextStyle}
          onClick={onClickBack}
        />
      </div>
      <div style={{ display: "inline-block" }}>
        <CustomButton
          title={"Verify"}
          design={classes.buttonStyle}
          onClick={onClickVerify}
        />
      </div>
    </div>
  );
};

const styles = {
  root: {},
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  descTextStyle: {
    ...getFontSize("medium"),
    ...getFontWeight("600"),
    color: "#818181",
    marginTop: 10,
  },
  textInputContainer: {
    height: 40,
  },
  inputContainer: {
    marginTop: 35,
    marginBottom: 35,
  },
  resendTextStyle: {
    maxWidth: "200px",
    color: "#1858b9",
    width: "100%",
    ...getFontWeight("600"),
    ...getFontSize("small"),
    "&:hover": {
      cursor: "pointer",
    },
  },
  buttonStyle: {
    width: 120,
    marginTop: 30,
  },
  backButton: {
    width: 120,
    marginTop: 30,
    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
};

export default withStyles(styles)(CustomOTP);
